import { $_CONFIG as config } from "./config.mjs";
import { aliases } from "./alias.mjs";
import { router } from "./router.mjs";
import { $_SLIDER as slider } from "./slider.mjs";

export const brandConfig = Object.assign({}, config, { aliases }, { router }, { slider })
